import styles from "./styles.module.scss";

export const DSRPApplication = () => {
  return (
    <div className={styles.trainAwsPdApplication}>
      <div className="container">
        <div className={styles.iframeContainer}>
          <iframe
            id="JotFormIFrame-240506610896155"
            title="The Coding School's Data Science Research Program"
            onload="window.parent.scrollTo(0,0)"
            allowtransparency="true"
            allowfullscreen="true"
            allow="geolocation; microphone; camera"
            src="https://form.jotform.com/240506610896155"
          >
          </iframe>
        </div>
      </div>
    </div>
  );
};
